export var linesFactory = length => {
  var numLines = [];
  numLines.length = length;
  numLines.fill(1);
  return numLines;
};
export var isLast = (length, index) => length - 1 === index;
//# sourceMappingURL=useSkeletonText.js.map